import { render } from "./TemoignagesView.vue?vue&type=template&id=75b6d3be&scoped=true"
import script from "./TemoignagesView.vue?vue&type=script&lang=js"
export * from "./TemoignagesView.vue?vue&type=script&lang=js"

import "./TemoignagesView.vue?vue&type=style&index=0&id=75b6d3be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b6d3be"]])

export default __exports__